import React from "react";

const LocationContext = React.createContext({
  refreshLocation: () => {},
});

export default LocationContext;
